"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.19.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierCurrency = void 0;
/**
 * Currency ISO 4217 code
 * @export
 * @enum {string}
 */
exports.SupplierCurrency = {
    Eur: 'EUR',
    Chf: 'CHF',
    Usd: 'USD',
    Gbp: 'GBP',
    Dkk: 'DKK',
    Sek: 'SEK',
    Nok: 'NOK',
    Mxn: 'MXN',
    Clp: 'CLP',
    Jpy: 'JPY',
    Aud: 'AUD',
    Cad: 'CAD',
    Hkd: 'HKD',
    Aed: 'AED',
    Zar: 'ZAR',
    Pln: 'PLN',
    Czk: 'CZK'
};
